import Button, { ButtonType } from "../../../../components/Button/Button";
import LinkButton, { LinkButtonType } from "../../../../components/LinkButton/LinkButton";
import Icon from "../../../../components/Icon/icon";
import { OrderDetail } from "../../../../interfaces/interfaces";
import { PaymentOption } from "../../../check-out/payment-selection/sendPaymentSelection";

export enum ResponseStatusTypes {
  "error",
  "success_unpaid",
  "success_paid",
  "success_confirming",
  "success_unavailable",
}

export const renderPaymentNZ = (order: OrderDetail) => {
  const isPaymentOnline = order.payment_method === PaymentOption.payOnline;

  if (!isPaymentOnline || order.payment_status === "unavailable") return null;
  if (order.payment_status === "paid") {
    return (
      <div className="payment-status-badge payment-status-badge--paid">
        <Icon name="CheckCircle" iconWidth="1.2rem" />
        <span>Payment Received</span>
      </div>
    );
  }
  if (order.payment_status === "confirming") {
    return (
      <div className="payment-status-badge payment-status-badge--confirming">
        <Icon name="HourglassHalf" iconWidth="1.2rem" />
        <span>Payment Confirming</span>
      </div>
    );
  }
  if (order.payment_status === "unpaid") {
    return (
      <LinkButton
        to={`/payment-form/${order.id}`}
        type={LinkButtonType.primary}
        target="_blank"
        className="pay-order-button"
      >
        Pay Order
      </LinkButton>
    );
  }
};

export const renderPayment = (
  responseStatus: ResponseStatusTypes | null,
  paymentSessionURL: string | null,
) => {
  if (responseStatus === ResponseStatusTypes.success_unpaid) {
    return (
      <LinkButton
        to={paymentSessionURL || ""}
        target="_blank"
        type={LinkButtonType.primary}
        className="pay-order-button"
      >
        Pay Order
      </LinkButton>
    );
  }
  if (responseStatus === ResponseStatusTypes.success_paid) {
    return (
      <div className="payment-status-badge payment-status-badge--paid">
        <Icon name="CheckCircle" iconWidth="1.2rem" />
        <span>Payment Received</span>
      </div>
    );
  }
  if (responseStatus === ResponseStatusTypes.success_confirming) {
    return (
      <div className="payment-status-badge payment-status-badge--confirming">
        <Icon name="HourglassHalf" iconWidth="1.2rem" />
        <span>Payment Confirming</span>
      </div>
    );
  }
  if (responseStatus === ResponseStatusTypes.success_unavailable) {
    return <></>;
  }
  if (responseStatus === ResponseStatusTypes.error) {
    return (
      <Button type={ButtonType.primary} disabled>
        Pay Order
      </Button>
    );
  }
};
